import { render, staticRenderFns } from "./ShippingInstructionParties.vue?vue&type=template&id=b99857c8&scoped=true&"
import script from "./ShippingInstructionParties.vue?vue&type=script&lang=js&"
export * from "./ShippingInstructionParties.vue?vue&type=script&lang=js&"
import style0 from "./ShippingInstructionParties.vue?vue&type=style&index=0&id=b99857c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99857c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b99857c8')) {
      api.createRecord('b99857c8', component.options)
    } else {
      api.reload('b99857c8', component.options)
    }
    module.hot.accept("./ShippingInstructionParties.vue?vue&type=template&id=b99857c8&scoped=true&", function () {
      api.rerender('b99857c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/shipping-instruction/ShippingInstructionParties.vue"
export default component.exports